// ======================================================================
// FILE:
// src/modules/service_crm/satisfaction/components/SatisfactionKpiBar.js
//
// MODULE: Service CRM
// FEATURE: Satisfaction KPI Bar
// ======================================================================

import React from "react";

export default function SatisfactionKpiBar({
  rows = [],
}) {

  const totalClosed =
    rows.length;

  const pending =
    rows.filter(
      (x) =>
        x.satisfaction_status ===
        "PENDING"
    ).length;

  const completed =
    rows.filter(
      (x) =>
        x.satisfaction_status ===
        "COMPLETED"
    ).length;

  const avgSatisfaction = (() => {

    const completedRows =
      rows.filter(
        (x) =>
          x.satisfaction_percentage
      );

    if (
      completedRows.length === 0
    ) {
      return 0;
    }

    const total =
      completedRows.reduce(

        (sum, row) =>
          sum +
          Number(
            row.satisfaction_percentage ||
            0
          ),

        0
      );

    return Math.round(
      total /
      completedRows.length
    );

  })();

  const cards = [

    {
      title:
        "Closed Tickets",

      value:
        totalClosed,

      color:
        "#0d6efd",

      icon:
        "📋",
    },

    {
      title:
        "Pending",

      value:
        pending,

      color:
        "#fd7e14",

      icon:
        "⏳",
    },

    {
      title:
        "Completed",

      value:
        completed,

      color:
        "#198754",

      icon:
        "✅",
    },

    {
      title:
        "Avg Satisfaction",

      value:
        `${avgSatisfaction}%`,

      color:
        "#6f42c1",

      icon:
        "⭐",
    },
  ];

  return (

    <div

      style={{

        display: "grid",

        gridTemplateColumns:
          "repeat(auto-fit,minmax(220px,1fr))",

        gap: 16,

        marginBottom: 20,
      }}
    >

      {cards.map((card) => (

        <div

          key={card.title}

          style={{

            background: "#fff",

            borderRadius: 14,

            padding: 18,

            boxShadow:
              "0 2px 8px rgba(0,0,0,0.08)",

            borderTop:
              `4px solid ${card.color}`,
          }}
        >

          <div

            style={{

              display: "flex",

              justifyContent:
                "space-between",

              alignItems:
                "center",
            }}
          >

            <div>

              <div

                style={{

                  fontSize: 12,

                  color: "#6c757d",

                  marginBottom: 6,
                }}
              >
                {card.title}
              </div>

              <div

                style={{

                  fontSize: 28,

                  fontWeight: 700,
                }}
              >
                {card.value}
              </div>

            </div>

            <div

              style={{

                fontSize: 28,
              }}
            >
              {card.icon}
            </div>

          </div>

        </div>
      ))}

    </div>
  );
}